// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".field-error {\n  margin-left: 15px;\n  color: #fb6340;\n  margin-top: 5px;\n}\n\n.field-error > i {\n  padding-right: 5px;\n}\n\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
